// ----------------------------------------------------------------------

export default function ListItem(theme) {
  return {
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: theme.spacing(0.5),
          paddingBottom: theme.spacing(0.5),
        },
      },
    },
  };
}
